module.exports = __webpack_public_path__ + "img/UTCORA-6.9320301e.jpg";